var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('SingleChart',{attrs:{"chart-options":_vm.chartOptions}}):_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-spinner',{style:({'color':_vm.constants.spinnerColor})})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }